import { Radio, RadioProps, styled } from "@mui/material";
import { forwardRef } from "react";

const CoreRadioUncheckedIcon = styled("span")(() => ({
	borderRadius: "50%",
	width: "16px",
	height: "16px",
	border: "1px solid #6f6f6f",
	backgroundColor: "#fff",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	transition: "background-color 100ms",
	"&::before": {
		borderRadius: "50%",
		width: "0%",
		height: "0%",
		content: "''",
		transition: "width 75ms, height 75ms, background-color 200ms",
	},
	"input:focus-visible ~ &": {
		outline: "2px solid var(--focus-outline-color-dark)",
		outlineOffset: "2px",
	},
	"input:hover:not(:disabled):not(:checked) ~ &::before": {
		borderRadius: "50%",
		width: "8px",
		height: "8px",
		content: "''",
		backgroundColor: "#E6E6E6",
	},
	"input:active:not(:disabled) ~ &": {
		backgroundColor: "#eef1f3",
		"::before": {
			width: "8px",
			height: "8px",
			border: "solid 1px #0b6f8544",
		},
	},
	"input:disabled ~ &": {
		border: "1px solid #949494",
		backgroundColor: "#e6e6e6",
	},
}));

const CoreRadioCheckedIcon = styled(CoreRadioUncheckedIcon)(() => ({
	"&::before": {
		borderRadius: "50%",
		width: "8px",
		height: "8px",
		content: "''",
		backgroundColor: "#0b6f85",
	},
	"input:disabled ~ &::before": {
		backgroundColor: "#0b6f85aa",
	},
}));

export const CoreRadio = forwardRef<
	HTMLButtonElement,
	Omit<RadioProps, "size"> & {
		size?: string | number;
		forceTabIndex?: boolean;
	}
>(function CoreRadio({ size, forceTabIndex = true, ...radioProps }, ref) {
	let tabIndex: number | undefined;
	if (forceTabIndex) {
		tabIndex = radioProps.checked ? 0 : -1;
	}
	return (
		<Radio
			{...radioProps}
			ref={ref}
			icon={<CoreRadioUncheckedIcon sx={{ width: size, height: size }} />}
			checkedIcon={<CoreRadioCheckedIcon sx={{ width: size, height: size }} />}
			disableRipple
			tabIndex={tabIndex}
		/>
	);
});
